import React, { useState, useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';

export const TiltCard = ({ 
  children, 
  className = '', 
  glareEnabled = true,
  tiltAmount = 10,
  perspective = 1000,
  scale = 1.02
}) => {
  const ref = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  
  const x = useMotionValue(0.5);
  const y = useMotionValue(0.5);
  
  const springConfig = { damping: 20, stiffness: 200 };
  const xSpring = useSpring(x, springConfig);
  const ySpring = useSpring(y, springConfig);
  
  const rotateX = useTransform(ySpring, [0, 1], [tiltAmount, -tiltAmount]);
  const rotateY = useTransform(xSpring, [0, 1], [-tiltAmount, tiltAmount]);
  
  const glareX = useTransform(xSpring, [0, 1], ['0%', '100%']);
  const glareY = useTransform(ySpring, [0, 1], ['0%', '100%']);

  const handleMouseMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const xPos = (e.clientX - rect.left) / rect.width;
    const yPos = (e.clientY - rect.top) / rect.height;
    x.set(xPos);
    y.set(yPos);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    x.set(0.5);
    y.set(0.5);
  };

  return (
    <motion.div
      ref={ref}
      className={`relative ${className}`}
      style={{
        perspective: perspective,
        transformStyle: 'preserve-3d'
      }}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={handleMouseLeave}
    >
      <motion.div
        className="relative w-full h-full"
        style={{
          rotateX: rotateX,
          rotateY: rotateY,
          scale: isHovered ? scale : 1,
          transformStyle: 'preserve-3d'
        }}
        transition={{ duration: 0.1 }}
      >
        {children}
        
        {/* Glare Effect */}
        {glareEnabled && isHovered && (
          <motion.div
            className="absolute inset-0 pointer-events-none rounded-xl overflow-hidden"
            style={{
              background: `radial-gradient(circle at ${glareX.get()} ${glareY.get()}, rgba(255,255,255,0.15) 0%, transparent 50%)`,
              mixBlendMode: 'overlay'
            }}
          />
        )}
      </motion.div>
    </motion.div>
  );
};

export default TiltCard;
